import { mapState } from 'vuex';
import f from '@/application/shared/functions.js'
import courseprogress from "../progress/index.vue";

export default {
    name: 'coursepreview',
    props: {
        course : Object,
        lessonNumber : Number
    },

    components : {
        courseprogress
    },

    data : function(){

        return {
            loading : false
        }

    },

    created () {
    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        ageCluster : function(){
            return f.findCluster(this.course.age, f.deep(this.core, 'appInfo.snippity.settings.ageClusters') || [])
        },
        auth : state => state.auth,
    }),

    methods : {
        click : function(){
            this.$router.push('/courses/' + this.course.uid)
        }
    },
}